import { useMeterBarChartInternalConfig } from '../context/MeterBarChartInternalConfigContext.js';
import { buildThresholds } from '../utils/build-thresholds.js';

export const useMeterBarChartThresholds = (
  displayValue: number,
  fallbackColor: string,
) => {
  const { min, max, thresholds, thresholdsIndicators } =
    useMeterBarChartInternalConfig();

  return buildThresholds(
    displayValue,
    min,
    max,
    fallbackColor,
    thresholds ?? thresholdsIndicators,
  );
};
